import { createRef, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { InputSwitch } from "primereact/inputswitch";
import { TextInput } from "../../../components/formLibs/FormLibs";
import "primeicons/primeicons.css";
import logoEcole229 from "../../../assets/images/logo.jpg";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import Authentification from "../../../api/Authentification";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { routes } from "../../../routes";
import useAuth from "../../../hooks/useAuth";

const Login = () => {
  const [checked, setChecked] = useState(false);
  const [iconPassword, setIconPassword] = useState(false);
  const [typeFieldPassword, setTypeFieldPassword] = useState(false);
  const recaptchaRef = createRef();
  const toast = useRef(null);
  const { setAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location?.state?.from?.pathname;

  const schema = Yup.object({
    email: Yup.string()
      .required("L'eamil est obligatoire")
      .email("Email invalide"),
    password: Yup.string().required("Le mot de passe est obligatoire"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleCLickIconPasswords = (e) => {
    e.preventDefault();
    setIconPassword(!iconPassword);
    setTypeFieldPassword(!typeFieldPassword);
  };

  const login = (data) => {
    setLoading(true);
    const recaptchaValue = recaptchaRef.current.getValue();
    if (!recaptchaValue) {
      toast.current.show({
        severity: "warn",
        summary: "Avertissement",
        detail: "Veuillez valider le captcha svp !",
        life: 3000,
      });
      setLoading(false);
    } else {
      Authentification.login(data)
        .then((res) => {
          if (res?.data?.error) {
            toast.current.show({
              severity: "error",
              summary: "Erreur",
              detail: "Identifiants incorects",
              life: 3000,
            });
            setLoading(false);
          } else if (res?.data?.message === "Account not activated") {
            toast.current.show({
              severity: "error",
              summary: "Compte inactif",
              detail: "Veuillez activer votre compte svp!",
              life: 3000,
            });
            setLoading(false);
          } else {
            const roles = res?.data?.roles;
            const permissions = res?.data?.permissions;
            const user = res?.data?.user;
            localStorage.setItem(
              "data",
              JSON.stringify({ user, roles, permissions })
            );
            setAuth({ user, roles, permissions });
            if (from && from === "/application") {
              navigate(from, { replace: true });
            } else {
              if (permissions.includes("passer_test_de_profil")) {
                navigate(routes.application.application, { replace: true });
              } else {
                navigate("/"+ routes.dashboard.statistic.path, { replace: true });
              }
            }
          }
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Identifiants incorects",
            life: 3000,
          });
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="auth__logo">
        <img src={logoEcole229} alt="logo_ecole229" />
      </div>
      <p className="mb-5 subtitle text-center">
        Renseignez vos informations de connexion !
      </p>
      <div className="auth__form">
        <form className="form" onSubmit={handleSubmit(login)}>
          <div className="form__item">
            <label htmlFor="Email">Email</label>
            <div className="form__item__ic_p">
              <TextInput
                type="email"
                name="email"
                label="email"
                register={register}
              />
              <i className="pi pi-envelope"></i>
            </div>
            <ErrorMsg>{errors.email?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="password">Mot de passe</label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="password"
                label="password"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <Link
                to="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </Link>
            </div>
            <ErrorMsg>{errors.password?.message}</ErrorMsg>
          </div>
          <div className="form__item form__item--flex">
            <div className="form__item__check">
              <InputSwitch
                checked={checked}
                onChange={(e) => setChecked(e.value)}
              />
              <span>Se souvenir de moi</span>
            </div>
            <p>
              <Link to={routes.auth + routes.forgotPassword}>
                Mot de passe oublié ?
              </Link>
            </p>
          </div>
          <div className="form__item">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_CAPTCHA_KEY}
            />
          </div>
          <div className="form__item">
            <button type="submit">
              Se connecter{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
          <div className="form__item form__item--last">
            <p>
              Vous n'avez pas un compte ?{" "}
              <Link to={routes.auth + routes.register}>Créer un compte</Link>
            </p>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
